<style>
    .page-result {
        background: #000;
        min-height: 100vh;
    }

    .dlg-golden {
        /* width: 6.84rem; */
    }

    .dlg-golden__head {
        height: 1.9rem;
        background: #000 url("../../../assets/img/reality/dlg_title.png") no-repeat 50% 100%;
        background-size: auto 100%;
    }

    .dlg-golden__body {
        background: #000 url("../../../assets/img/reality/dlg_bian.png") no-repeat 50% 50%;
        background-size: 100% 100%;
    }

    .dlg-golden__foot {
        height: 1.9rem;
        background: #000 url("../../../assets/img/reality/dlg_bottom.png") no-repeat 50% 0;
        background-size: auto 100%;
    }

    .dlg-golden__content {
        width: 5.4rem;
        margin: 0 auto;
        font-size: .30rem;
        line-height: 1.5;
        color: #FFB705;
    }

    .dlg-golden__footInner {

        width: 5.4rem;
        margin: 0 auto;
        padding: .8rem 0 0;
    }

    .dlg-golden__btns {
        position: relative;
        width: 100%;
        height: 1rem;
        margin: 0 auto;
        /* background: #f00; */
    }

    .dlg-golden__btn {
        position: absolute;
        top: 50%;
        display: block;
        width: 50%;
        margin-top: -.39rem;
        line-height: .78rem;
        text-align: center;
    }

    .dlg-golden__btn span {
        visibility: hidden;
    }

    .dlg-golden__btn.lt {
        left: 0;
        background: url("../../../assets/img/reality/play/dlg_btn_my_detail.png") no-repeat 50% 0;
        background-size: auto 100%;
    }

    .dlg-golden__btn.rt {
        right: 0;
        background: url("../../../assets/img/reality/play/dlg_btn_my_games.png") no-repeat 50% 0;
        background-size: auto 100%;
    }


    .dlg-silver {
        /* width: 6.84rem; */
    }

    .dlg-silver__head {
        height: 1.2rem;
        background: #000 url("../../../assets/img/reality/biankuang2.png") no-repeat 50% 100%;
        background-size: auto 100%;
    }

    .dlg-silver__body {
        background: #000 url("../../../assets/img/reality/biankuang0.png") no-repeat 50% 50%;
        background-size: 100% 100%;
        padding: 0 0 .3rem;
    }

    .dlg-silver__foot {
        position: relative;
        top: 0;
        left: 0;
        height: 1.2rem;
        background: #000 url("../../../assets/img/reality/biankuang1.png") no-repeat 50% 0;
        background-size: auto 100%;
    }
    .dlg-silver__content {
        width: 6.4rem;
        margin: 0 auto;
        text-align: left;
        color: #F8E71C;
        font-size: .34rem;
        line-height: 1.5;
        padding: 0 0 .3rem;
    }

    .dlg-silver__btns {
        position: absolute;
        top: -.3rem;
        left: 50%;
        right: 0;
        width: 6rem;
        margin-left: -3rem;
    }

    .k-button {
        text-align: center;
    }
    .k-button-big {
        height: .84rem;
        line-height: .84rem;
        border-radius: .2rem;
        font-size: .34rem;
    }
    .k-button-red {
        color: #FFE55E;
        background-image: linear-gradient(-180deg, #E75654 0%, #E13033 14%, #921C1C 82%);
    }
    .k-button-block {
        display: block;
    }

</style>

<template>
    <div class="page page-result">
        <p>&nbsp;</p>
        <div class="dlg-golden">
            <div class="dlg-golden__head">

            </div>
            <div class="dlg-golden__body">
                <div class="dlg-golden__content">
                    <p>完成了决赛，<span class="cl_danger">{{finalRes|time2text}}</span>公布成绩，成绩公布后可以在活动首页或决赛页面查看总体成绩、决赛排行榜以及获奖名单。</p>
                </div>
            </div>
            <div class="dlg-golden__foot">
                <div class="dlg-golden__footInner">
                    <div class="dlg-golden__btns">
                        <router-link class="dlg-golden__btn lt r-eid-rfDetail" to="/match/my"><span>我的战况</span></router-link>
                        <router-link class="dlg-golden__btn rt r-eid-rfGames" to="/reality/games"><span>决赛记录</span></router-link>
                    </div>
                </div>
            </div>
        </div>
        <p>&nbsp;</p>
        <div class="dlg-silver">
            <div class="dlg-silver__head"></div>
            <div class="dlg-silver__body">
                <div class="dlg-silver__content">
                    <p>新浪理财大学推出王者《碎片化创新语音课》干货提炼，交易日实盘语音精确及时指导！</p>
                </div>
            </div>
            <div class="dlg-silver__foot">
                <div class="dlg-silver__btns">
                    <a class="k-button k-button-big k-button-red k-button-block  r-eid-adVipAudioRF" :href="getUrl('vipAudio')">了解详情</a>
                </div>
            </div>
        </div>

        <br>
        <br>
        <br>


    </div>
</template>

<script>
    import {
        // mapState,
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        props: ['cupId', 'gameId', 'kid'],
        components: {

        },
        computed: {
            ...mapGetters(['realityCupId', 'finalRes', 'getUrl']),
            ...mapGetters('reality', ['getActionBy', 'getKlineAt']),
            ...mapGetters('reality', {
                // cupId: 'curCupId',
                // gameId: 'curGameId',
                // kid: 'curKid',
                klines: 'playKlines',
                actions: 'playActions'
            }),
            yesterday() {
                return this.getKlineAt(-2)
            },
            today() {
                return this.getKlineAt(-1)
            },
            curAction() {
                return this.getActionBy(this.kid)
            }
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'fetchData'
        },
        methods: {
            ...mapActions('reality', ['loadPlay']),
            fetchData() {
                const {
                    cupId,
                    gameId,
                    kid
                } = this
                // console.log({cupId, gameId})

                this.loadPlay({
                    cupId,
                    gameId,
                    kid
                })
            }
        },
        async created() {
            this.fetchData()
        }
    };

</script>
